import { ref, computed } from "vue";
import { localStorageGetAuthType } from "@/common/localStorageUtil";

/**
 * 仮会員QRコード画面のUI状態管理
 * エラーダイアログの表示制御と、ユーザ権限（店舗/本部）の判定を提供する。
 *
 * @returns errDialog - エラーダイアログ表示フラグ
 * @returns errMessage - エラーメッセージ
 * @returns authType - ユーザ権限（"0":店舗, "1":本部）
 * @returns isStore - 店舗権限かどうか
 * @returns isHQ - 本部権限かどうか
 * @returns showError - エラーダイアログを表示する
 */
export const useTmpMemberQrCodeUiState = () => {
  const errDialog = ref(false);
  const errMessage = ref("");

  // 権限（"0": 店舗, "1": 本部）
  const authType = ref<string | null>(localStorageGetAuthType());
  const isStore = computed(() => authType.value === "0");
  const isHQ = computed(() => authType.value === "1");

  /**
   * エラーダイアログを表示する
   */
  const showError = (msg: string): void => {
    errMessage.value = msg;
    errDialog.value = true;
  };

  return {
    errDialog,
    errMessage,
    authType,
    isStore,
    isHQ,
    showError,
  };
};
